import Core from "./Variants/Core";

const AsyncSelect = ({
  name,
  options,
  label,
  placeholder,
  alertType,
  alertMessage,
  prefix,
  required,
  disabled,
  size,
  request,
  ...rest
}) => {
  return (
    <Core
      name={name}
      options={options}
      label={label}
      placeholder={placeholder}
      alertType={alertType}
      alertMessage={alertMessage}
      prefix={prefix}
      required={required}
      size={size}
      disabled={disabled}
      request={request}
      {...rest}
    />
  );
};

export default AsyncSelect;
